import './WorkingProcess.css'

function WorkingProcess(){
    return(
        <>
            <div className="Container">
                <h3>Working Process</h3>
                <h2>How we works?</h2>
                <div className="cards" >
                    <div className="card col-md-4 col-lg-4">
                        <h2>01</h2>
                        <h3>Make Appointmnet</h3>
                        <p>It is a long established fact that a reader will be distracted by the readable content of.</p>
                        <button>View More<span><i className="fa-solid fa-chevron-right"></i></span></button>
                    </div>
                    <div className="card center col-md-4 col-lg-4">
                        <h2>02</h2>
                        <h3>Take Treatment</h3>
                        <p>It is a long established fact that a reader will be distracted by the readable content of.</p>
                        <button>View More<span><i className="fa-solid fa-chevron-right"></i></span></button>
                    </div>
                    <div className="card col-md-4 col-lg-4">
                        <h2>03</h2>
                        <h3>Registration</h3>
                        <p>It is a long established fact that a reader will be distracted by the readable content of.</p>
                        <button>View More<span><i className="fa-solid fa-chevron-right"></i></span></button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default WorkingProcess;